import { asHintId, type Hint } from '@/shared/stores';

import { COPILOT_ORDERS_CHIP_ANCHOR } from './anchors';

export const ordersChipHint: Hint = {
  id: asHintId('patient-workspace:orders-chip'),
  version: 1,
  priority: 40,
  anchor: COPILOT_ORDERS_CHIP_ANCHOR,
  copy: {
    title: 'Click to order, or just ask',
    body: 'Use the Orders chip anytime to start a prescription or lab order yourself. Cortex can also draft and queue them for you — just ask in the composer.',
    primaryLabel: 'Got it',
    secondaryLabel: 'Skip',
  },
};
